export default (theme) => ({
  containerMobile: {
    maxWidth: "100%",
  },
  container: {
    maxWidth: "80%",
  },
});
